import { render, staticRenderFns } from "./Gates.vue?vue&type=template&id=1e89832c"
import script from "./Gates.vue?vue&type=script&lang=js"
export * from "./Gates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports